import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../component/shareModule';
import {CasePracticeStageStartComponent} from './case-practice-stage-start/case-practice-stage-start.component';
import {CasePracticeStageEndComponent} from './case-practice-stage-end/case-practice-stage-end.component';
import {CasePracticeSceneChangeComponent} from './case-practice-scene-change/case-practice-scene-change.component';


@NgModule({
	  imports: [CommonModule],
    providers : [CasePracticeStageStartComponent, CasePracticeStageEndComponent, CasePracticeSceneChangeComponent],
    declarations: [CasePracticeStageStartComponent, CasePracticeStageEndComponent, CasePracticeSceneChangeComponent],
    exports: [CasePracticeStageStartComponent, CasePracticeStageEndComponent, CasePracticeSceneChangeComponent]
})

export class CasePracticeAnimationModule{

}



// WEBPACK FOOTER //
// ./src/app/case-practice-animation/case-practice-animation.module.ts